//-----------------------------------------------------
// -- current
//-----------------------------------------------------
export var current = function () {
	var nowurl = location.pathname;
	$('.header_gnav').find('li').each(function(index, el) {
		if (location.pathname === $(this).find('a').attr('href')) {
			if (nowurl.indexOf('feature') !== -1) {
				$(this).addClass('current');
				$(this).parents('li.has_child').addClass('current');
			} else {
				$(this).addClass('current');
			}
		}
	});
};
